/**
 * API configuration
 */

const DEV_FRONTEND_HOST = 'dev.thinklet-journal.com';
const DEV_API_URL = 'https://api.dev.thinklet-journal.com';
const LEGACY_PROD_API_URL = 'https://api.thinklet-journal.com';

const getApiBaseUrl = (): string => {
  const configuredApiUrl = process.env.REACT_APP_API_URL;

  if (typeof window !== 'undefined' && window.location.hostname === DEV_FRONTEND_HOST) {
    if (!configuredApiUrl || configuredApiUrl === LEGACY_PROD_API_URL) {
      return DEV_API_URL;
    }
  }

  if (process.env.NODE_ENV === 'production') {
    return configuredApiUrl || LEGACY_PROD_API_URL;
  }
  return configuredApiUrl || 'https://localhost:8000';
};

export const API_CONFIG = {
  BASE_URL: getApiBaseUrl(),
  WS_URL: getApiBaseUrl().replace('https://', 'wss://').replace('http://', 'ws://'),
  ENDPOINTS: {
    USERS: '/api/v1/users',
    DEVICES: '/api/v1/devices',
    NETWORK: '/api/v1/network-status',
    DATA: '/api/data',
    PERSONS: '/api/v1/persons',
  },
  TIMEOUT: 30000, // 30 seconds
} as const;
